export const EUserType = {
  "0": "UNKNOWN",
  "1": "STAFF",
  "2": "AGENCY_ADMIN",
  "3": "AGENCY_USER",
  "4": "CUSTOMER",
  "5": "API_USER",
  "6": "EXTRANET_USER",
  "-1": "ALL"
};

export const EUsrOperatorTaskAvailabilty = {
  "0": "UNKNOWN",
  "1": "AVAILABLE",
  "2": "ON_BREAK",
  "3": "AT_MEAL",
  "4": "IN_MEETING",
  "5": "IN_EDUCATION",
  "6": "OUT_OFF_HOURS",
  "-1": "ALL"
};

export const EUsrOperatorCallAvailabilty = {
  "0": "UNKNOWN",
  "1": "AVAILABLE",
  "2": "DONT_DISTURB",
  "-1": "ALL"
};

export const EUserTotp = {
  "0": "UNKNOWN",
  "1": "ON",
  "2": "OFF",
  "3": "RESET",
  "-1": "ALL"
};

export const EUserLoginStatus = {
  "0": "UNKNOWN",
  "1": "SUCCESS",
  "2": "WRONG_EMAIL",
  "3": "WRONG_PASSWORD",
  "4": "WRONG_TOTP",
  "5": "WRONG_DOMAIN",
  "6": "USER_BLOCKED",
  "7": "TOTP_RESET",
  "-1": "ALL"
};

export const EUserOnBeHalfOfStatus = {
  "0": "UNKNOWN",
  "1": "TOKEN_CREATED",
  "2": "SWITCHED_OK",
  "3": "SWITCHED_NOK",
  "-1": "ALL"
};